<template>
   <div class="approveLogs">
        <sheet-logs
            :companyId="companyId"
            :appId="appId"
            :urlParams="urlParams"
            :params="params"
        ></sheet-logs>
   </div>
</template>

<script>
    import sheetLogs from "@/views/menu/sheet/attach/sheetLogs.vue";

    export default {
        name: "approveLogs",
        components: {
            sheetLogs
        },
        props: {
            companyId: {
                type: String,
                required: true
            },
            appId: {
                type: String,
                required: true
            },

            approveData: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        data () {
            return {};
        },
        computed: {
            flowInstId () {
                return this.approveData.flow_inst && this.approveData.flow_inst._id;
            },
            urlParams () {
                return {
                    module: "flowInst",
                    name: "changeLog",
                    params: {
                        companyId: this.companyId,
                        appId: this.appId
                    }
                };
            },
            params () {
                return {
                    flow_inst: this.flowInstId
                };
            }
        },
        created () {},
        methods: {}
    };
</script>



// WEBPACK FOOTER //
// src/views/flow/approve/approveModal/approveLogs.vue